/** Standard toast display durations (ms). 0 = persists until dismissed. */
export const TOAST_DURATION = {
  SHORT: 4000,
  LONG: 10000,
  PERSISTENT: 0,
} as const;
